import { IStaticFilter } from "../../models/base/base-query";
import { StorStatus } from "../../models/store/enum";

export const createActiveStoreFilter = (): IStaticFilter => ({
  name: "status",
  value: StorStatus.ACTIVE,
  operation: "eq",
});

export const createNamlieahStoreFilter = (): IStaticFilter => ({
  name: "isNamlieah",
  value: 1,
  operation: "eq",
});

export const createActiveNamlieahStoreFilters = (): IStaticFilter[] => [
  createNamlieahStoreFilter(),
  createActiveStoreFilter(),
];
